type  PlanSyncOptionsType = {
    nothing: 'nothing',
    backup: 'backup',
    restore: 'restore',
}
export const  PlanSyncOptions:  PlanSyncOptionsType = {
    nothing: 'nothing',
    backup: 'backup',
    restore: 'restore',
}

export type  PlanSyncOptionsValues = typeof  PlanSyncOptions[keyof typeof  PlanSyncOptions]

export const AllPlanSyncOptions:  PlanSyncOptionsValues[] = Array.from(Object.values( PlanSyncOptions));

export default  PlanSyncOptions;